import { Mesh, MeshLambertMaterial, PlaneGeometry, RepeatWrapping } from "three"
import type { Engine } from "../../../core/engine/Engine.type"
import tmpRng from "../../../core/rng/tmpRng"
import { HALF_PI, sin } from "../../../core/util/math/Math"
import { cosCached, sinCached } from "../../../core/util/trigonometryCache"
import { mountOnFrameUpdateToObject3D } from "../../../event/GameObject3D/GameObject3DFrameUpdate/GameObject3DFrameUpdate"
import { VERTICES_PER_TILE } from "../../consts"
import generateNoiseTexture from "../../fn/generateNoiseTexture"

/**
 * 
 */
export default function createWaterPlaneMesh(
  engine: Engine,
  width: number,
  height: number,
) {
  const textureSize = 64 * 4
  const textureRepeatSize = 0.5
  const noiseTexture1 = generateNoiseTexture(textureSize, tmpRng, 127, 255)
  noiseTexture1.wrapS = noiseTexture1.wrapT = RepeatWrapping
  noiseTexture1.repeat.set(textureRepeatSize, textureRepeatSize)

  const noiseTexture2 = generateNoiseTexture(textureSize, tmpRng, 127, 255)
  noiseTexture2.wrapS = noiseTexture2.wrapT = RepeatWrapping
  noiseTexture2.repeat.set(textureRepeatSize, textureRepeatSize)

  const textureSize3 = 32
  const textureRepeatSize3 = 0.125
  const noiseTexture3 = generateNoiseTexture(textureSize3, tmpRng, 127, 255)
  noiseTexture2.wrapS = noiseTexture2.wrapT = RepeatWrapping
  noiseTexture2.repeat.set(textureRepeatSize3, textureRepeatSize3)

  // const noise2D = createSeededNoise2D(1)
  // const noiseTexture3 = generateSmoothNoiseTexture(textureSize, 10, 0.5, 0.5, noise2D)

  const material = new MeshLambertMaterial({
    // color: 0x0000ff,
    color: 0x4A90E2, // RiverBlue

    bumpMap: noiseTexture1,

    lightMap: noiseTexture2,
    lightMapIntensity: 1,

    aoMap: noiseTexture3,
    aoMapIntensity: 1,

    transparent: true,
    opacity: 0.65,
    // forceSinglePass: true,

    // side: BackSide,
    // side: FrontSide,
  })

  // material.visible = false

  // createMountedInverval(() => {
  //   console.log('material.specularMap', material.specularMap)
  //   material.specularMap = material.specularMap === noiseTexture3 ? null : noiseTexture3
  //   material.needsUpdate = true
  // }, 2000)

  const geometryWidth = width * VERTICES_PER_TILE
  const geometryHeight = height * VERTICES_PER_TILE
  const geometry = new PlaneGeometry(geometryWidth, geometryHeight)
  const mesh = new Mesh(geometry, material)
  mesh.name = 'WaterPlane'

  mesh.rotation.x = -HALF_PI

  const worldX = ((width - 1) * VERTICES_PER_TILE) / 2
  const worldY = ((height - 1) * VERTICES_PER_TILE) / 2
  const rh = 0
  mesh.position.set(worldX, rh, worldY)
  // mesh.position.z += 5

  mountOnFrameUpdateToObject3D(engine, mesh, (dt: number, at: number) => {
    material.opacity = 0.6 + (0.05 * sin(at / 500))
    material.aoMapIntensity = 0.6 + (0.05 * sin(at / 500))
    noiseTexture1.offset.x += 0.0002
    noiseTexture1.offset.y += 0.0002
    noiseTexture2.offset.x -= 0.000125
    noiseTexture2.offset.y -= 0.000125
    noiseTexture3.offset.x += sinCached(at / 100000) / 100000
    noiseTexture3.offset.y += cosCached(at / 100000) / 100000
  })

  // mesh.visible = false
  // material.wireframe = true

  return mesh
}